import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32353074"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "athority-label-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_new_tree = _resolveComponent("new-tree")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.treeData, (item) => {
    return (_openBlock(), _createElementBlock("div", {
      key: item.identify,
      style: {"margin-top":"15px"}
    }, [
      (item.type == 1 || item.type == 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["df vertical", 'athority-distance-' + _ctx.props.distanceIndex])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_a_checkbox, {
                checked: item.active,
                "onUpdate:checked": ($event: any) => ((item.active) = $event),
                class: "custom-checkbox",
                onChange: ($event: any) => (_ctx.selectAuthority(item)),
                indeterminate: item.indeterminate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["checked", "onUpdate:checked", "onChange", "indeterminate"])
            ])
          ], 2))
        : _createCommentVNode("", true),
      (
        item.children && item.children.length > 0 && item.children[0].type == 2
      )
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["df vertical", 'permission-distance-' + _ctx.props.distanceIndex])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subItem) => {
              return (_openBlock(), _createElementBlock("div", {
                key: subItem.identify,
                class: "athority-label-name authority-space"
              }, [
                _createVNode(_component_a_checkbox, {
                  checked: subItem.active,
                  "onUpdate:checked": ($event: any) => ((subItem.active) = $event),
                  class: _normalizeClass([_ctx.index > 0 ? 'subItem' : '', "custom-checkbox"]),
                  onClick: ($event: any) => (_ctx.checkSuperior(subItem))
                }, null, 8, ["checked", "onUpdate:checked", "class", "onClick"]),
                _createTextVNode(_toDisplayString(subItem.name), 1)
              ]))
            }), 128))
          ], 2))
        : _createCommentVNode("", true),
      (item.children && item.children.length > 0)
        ? (_openBlock(), _createBlock(_component_new_tree, {
            key: 2,
            treeData: item.children,
            distanceIndex: _ctx.props.distanceIndex + 1,
            onAddMenuById: _ctx.addMenuById,
            onAddPerssionById: _ctx.addPerssionById,
            onToEdit: _ctx.toEdit,
            onToDelete: _ctx.toDelete,
            point: _ctx.props.point
          }, null, 8, ["treeData", "distanceIndex", "onAddMenuById", "onAddPerssionById", "onToEdit", "onToDelete", "point"]))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}